import React, { useCallback } from 'react'

import { AllEstateFeatures, FieldProps, YesOrNo, YesOrNoString } from '../../../../../../../@types/types'
import { AbstractScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

export interface EstateFeaturesYesOrNoChipOptionFieldProps extends FieldProps<AbstractScreenValidationResult> {
  invertLogic?: boolean
  estateFeatureKey: AllEstateFeatures
  labelTranslationKey: string
  id: string
  disabled?: boolean
}

function mapEstateFeatureValue(value: string, invertLogic: boolean) {
  switch (value as YesOrNo) {
    case YesOrNo.NO:
      return invertLogic ? true : false
    case YesOrNo.YES:
      return invertLogic ? false : true
    case YesOrNo.NO_INFORMATION:
    default:
      return undefined
  }
}

function mapChipValue(value: boolean | undefined, invertLogic: boolean) {
  if (value === true) {
    return invertLogic ? YesOrNo.NO : YesOrNo.YES
  } else if (value === false) {
    return invertLogic ? YesOrNo.YES : YesOrNo.NO
  } else {
    return YesOrNo.NO_INFORMATION
  }
}

const EstateFeaturesYesOrNoChipOptionField: React.FC<EstateFeaturesYesOrNoChipOptionFieldProps> = ({
  insertionData,
  screenName,
  onChange,
  wrapperClassName = getDefaultClasses('full'),
  invertLogic = false,
  disabled = false,
  estateFeatureKey,
  labelTranslationKey,
  id,
}) => {
  const estateFeatureValue = insertionData.estateFeatures?.[estateFeatureKey]

  const selectedOption = mapChipValue(estateFeatureValue, invertLogic)

  const handleChange = useCallback(
    (value: string) => {
      onChange(
        { screen: screenName, property: `estateFeatures.${estateFeatureKey}` },
        mapEstateFeatureValue(value, invertLogic)
      )
    },
    [onChange, screenName, invertLogic, estateFeatureKey]
  )

  return (
    <div className={wrapperClassName}>
      <ChipOptionField
        id={id}
        option={selectedOption}
        options={YesOrNoString}
        translation={'wizard.screen.otherFacilities.'}
        labelTranslationKey={labelTranslationKey}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  )
}

export default EstateFeaturesYesOrNoChipOptionField
